var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 264,
    viewBox: "0 0 244 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.701 169.668V93.5235C243.701 73.706 233.132 55.406 215.97 45.5062L150.014 7.4248C132.853 -2.47493 111.716 -2.47493 94.5723 7.4248L28.6344 45.5062C11.4724 55.406 0.904297 73.706 0.904297 93.5235V169.668C0.904297 189.486 11.4724 207.786 28.6344 217.686L94.5904 255.767C111.752 265.667 132.889 265.667 150.033 255.767L215.989 217.686C233.132 207.786 243.701 189.486 243.701 169.668Z",
    fill: "#A6A6A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector1.a8489252c1a6194357d2fc54518bd6d6.svg";
export { ForwardRef as ReactComponent };